import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const Certifications = () => {
  const certifications = [
  {
    title: "Halal Certification",
    issuer: "Halal India Certification Services",
    description: "All our ingredients and preparation processes are certified 100% halal, ensuring complete compliance with Islamic dietary laws",
    icon: "Award",
    image: "https://images.unsplash.com/photo-1559439071-af1feb6fb5e8",
    imageAlt: "Official halal certification document with green seal and Arabic calligraphy displayed on white background with professional lighting"
  },
  {
    title: "FSSAI License",
    issuer: "Food Safety and Standards Authority of India",
    description: "Licensed and regularly inspected for food safety standards, maintaining highest hygiene and quality protocols",
    icon: "ShieldCheck",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10bdf11cc-1764582861193.png",
    imageAlt: "FSSAI food safety license certificate with official government seal and registration number displayed in professional frame"
  },
  {
    title: "ISO 22000:2018",
    issuer: "International Organization for Standardization",
    description: "Certified food safety management system ensuring consistent quality and safety across all our locations",
    icon: "CheckCircle",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a5b30249-1764582861550.png",
    imageAlt: "ISO 22000 food safety management certificate with blue border and official ISO logo on premium paper"
  }];


  const qualityCommitments = [
  {
    icon: "Eye",
    title: "Full Transparency",
    description: "Complete ingredient disclosure and sourcing information available on request"
  },
  {
    icon: "Thermometer",
    title: "Temperature Control",
    description: "Strict cold chain management and cooking temperature monitoring"
  },
  {
    icon: "Users",
    title: "Staff Training",
    description: "Regular food safety and hygiene training for all team members"
  },
  {
    icon: "ClipboardCheck",
    title: "Daily Inspections",
    description: "Internal quality checks performed multiple times daily"
  }];


  return (
    <section className="py-20 bg-card">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">
            Certifications & <span className="text-primary">Quality Standards</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Trust built through transparency and certified excellence
          </p>
        </div>

        <div className="space-y-12 mb-16">
          {certifications?.map((cert, index) =>
          <div
            key={index}
            className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center animate-slide-up`}
            style={{ animationDelay: `${index * 100}ms` }}>

              <div className="lg:w-1/2">
                <div className="relative rounded-2xl overflow-hidden shadow-lg h-80">
                  <Image
                  src={cert?.image}
                  alt={cert?.imageAlt}
                  className="w-full h-full object-cover" />

                </div>
              </div>
              <div className="lg:w-1/2">
                <div className="bg-background p-8 rounded-xl border border-border">
                  <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center mb-6">
                    <Icon name={cert?.icon} size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-2xl font-bold text-foreground mb-2">{cert?.title}</h3>
                  <p className="text-sm text-primary font-semibold mb-4">{cert?.issuer}</p>
                  <p className="text-muted-foreground leading-relaxed text-lg">{cert?.description}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="bg-background rounded-2xl p-8 border border-border">
          <h3 className="text-2xl font-bold text-foreground mb-8 text-center">
            Our Quality Commitments
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {qualityCommitments?.map((commitment, index) =>
            <div
              key={index}
              className="text-center animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}>

                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name={commitment?.icon} size={28} color="var(--color-primary)" />
                </div>
                <h4 className="text-lg font-semibold text-foreground mb-2">{commitment?.title}</h4>
                <p className="text-sm text-muted-foreground">{commitment?.description}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default Certifications;